import { reportPermissions } from '../../helpers/permissions'

export default [
  {
    path: '/reports-analytics/financial-report',
    name: 'financial-reports',
    component: () => import('@/views/pages/reports/FinancialReport.vue'),
    meta: {
      pageTitle: 'Financial Reports',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Financial Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/operational-report',
    name: 'operational-reports',
    component: () => import('@/views/pages/reports/OperationalReport.vue'),
    meta: {
      pageTitle: 'Operational Reports',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Operational Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/newly-opened-account-report',
    name: 'newly-opened-account-report',
    component: () => import('@/views/pages/reports/Operational/NewlyOpenedAccount.vue'),
    meta: {
      pageTitle: 'Newly Opened Account Reports',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Newly Opened Account Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/bvn-nin-compliance-report',
    name: 'bvn-nin-compliance-report',
    component: () => import('@/views/pages/reports/Operational/BVNNINComplianceReport.vue'),
    meta: {
      pageTitle: 'BVN/NIN Compliance Reports',
      hasPermission: 'VIEW_COMPLIANCE_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'BVN/NIN Compliance Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/regulatory-report',
    name: 'regulatory-reports',
    component: () => import('@/views/pages/reports/RegulatoryReport.vue'),
    meta: {
      pageTitle: 'Regulatory Reports',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Regulatory Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/overdraft-report',
    name: 'overdraft-report',
    component: () => import('@/views/pages/reports/Credit-Loan/OverdraftReport.vue'),
    meta: {
      pageTitle: 'Overdraft Report',
      hasPermission: 'OVERDRAFT_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Overdraft Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/closed-loan-report',
    name: 'closed-loan-report',
    component: () => import('@/views/pages/reports/Credit-Loan/ClosedLoanReport.vue'),
    meta: {
      pageTitle: 'Closed Loan Report',
      hasPermission: 'VIEW_CLOSED_ACCOUNTS',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Closed Loan Report',
          active: true,
        },
      ],
    },
  },

  {
    path: '/reports-analytics/download-manager',
    name: 'download-manager',
    component: () => import('@/views/pages/reports/Operational/DownloadManagerReport.vue'),
    meta: {
      pageTitle: 'Download Manager',
      hasPermission: 'VIEW_REPORT_DOWNLOADS',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Download Manager',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/customer-account-balance-report',
    name: 'customer-account-balance-report',
    component: () => import(
      '@/views/pages/reports/Operational/CustomerAccountBalanceReport.vue'
    ),
    meta: {
      pageTitle: 'Customer Account Balance',
      hasPermission: 'ACCOUNT_BALANCE_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Customer Account Balance',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/gl-balance-history-report',
    name: 'gl-balance-history-report',
    component: () => import('@/views/pages/reports/Operational/GlBalanceHistoryReport.vue'),
    meta: {
      pageTitle: 'GL Balance History Report',
      hasPermission: 'GL_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'GL Balance History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/savings-accrual-history-report',
    name: 'savings-accrual-history-report',
    component: () => import(
      '@/views/pages/reports/Operational/SavingsAccrualHistoryReport.vue'
    ),
    meta: {
      pageTitle: 'Savings Accrual History Report',
      hasPermission: 'SAVINGS_ACCRUAL_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Savings Accrual History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/loan-accrual-history-report',
    name: 'loan-accrual-history-report',
    component: () => import('@/views/pages/reports/Operational/LoanAccrualHistoryReport.vue'),
    meta: {
      pageTitle: 'Loan Accrual History Report',
      hasPermission: 'LOAN_ACCRUAL_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Loan Accrual History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/fixed-deposit-accrual-history-report',
    name: 'fixed-deposit-accrual-history-report',
    component: () => import(
      '@/views/pages/reports/Operational/FixedDepositAccrualHistoryReport.vue'
    ),
    meta: {
      pageTitle: 'Fixed Deposit Accrual History Report',
      hasPermission: 'FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Fixed Deposit Accrual History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/overdraft-accrual-history-report',
    name: 'overdraft-accrual-history-report',
    component: () => import(
      '@/views/pages/reports/Operational/OverdraftAccrualHistoryReport.vue'
    ),
    meta: {
      pageTitle: 'Overdraft Accrual History Report',
      hasPermission: 'OVERDRAFT_ACCRUAL_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Overdraft Accrual History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/customer-account-balance-history-report',
    name: 'customer-account-balance-history-report',
    component: () => import(
      '@/views/pages/reports/Operational/CustomerAccountBalanceHistoryReport.vue'
    ),
    meta: {
      pageTitle: 'Account Balance History Report',
      hasPermission: 'ACCOUNT_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Account Balance History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/customer-account-history-report',
    name: 'customer-account-history-report',
    component: () => import('@/views/pages/reports/Posting/CustomerAccountHistoryReport.vue'),
    meta: {
      pageTitle: 'Customer Account History',
      hasPermission: 'ACCOUNT_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Customer Account History',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/transaction-callover-report',
    name: 'transaction-callover-report',
    component: () => import('@/views/pages/reports/Posting/TransactionCallOverReport.vue'),
    meta: {
      pageTitle: 'Transaction CallOver',
      hasPermission: 'TRANSACTION_CALLOVER_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Transaction CallOver',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/gl-history-report',
    name: 'gl-history-report',
    component: () => import('@/views/pages/reports/Posting/GlHistoryReport.vue'),
    meta: {
      pageTitle: 'GL History Report',
      hasPermission: 'GL_HISTORY_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'GL History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/eod-transaction-report',
    name: 'eod-transaction-report',
    component: () => import('@/views/pages/reports/Posting/EODTransactionReport.vue'),
    meta: {
      pageTitle: 'EOD Transaction Report',
      hasPermission: 'END_OF_DAY_TRANSACTION_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'EOD Transaction Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/loan-tracking-report',
    name: 'loan-tracking-report',
    component: () => import('@/views/pages/reports/Credit-Loan/Loans/LoanTracking.vue'),
    meta: {
      pageTitle: 'Loan Tracking Report',
      hasPermission: 'LOAN_TRACKING_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Loan Tracking Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/loan-and-advances',
    name: 'loan-and-advances',
    component: () => import('@/views/pages/reports/Credit-Loan/Loans/LoanAndAdvances.vue'),
    meta: {
      pageTitle: 'Loan and Advances Report',
      hasPermission: 'LOAN_AND_ADVANCES_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Loan and Advances Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/loan-collections-report',
    name: 'loan-collections-report',
    component: () => import('@/views/pages/reports/Credit-Loan/LoanCollectionsReport.vue'),
    meta: {
      pageTitle: 'Loan Collections Report',
      hasPermission: 'LOAN_COLLECTIONS_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Loan Collections Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/remita-collections-report',
    name: 'remita-collections-report',
    component: () => import(
      '@/views/pages/reports/Credit-Loan/Loans/RemitaCollectionsReport.vue'
    ),
    meta: {
      pageTitle: 'Remita Collections Report',
      hasPermission: 'VIEW_REMITA_COLLECTIONS_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Remita Collections Report',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/reports-analytics/on-lending-report',
  //   name: 'on-lending-report',
  //   component: () => import('@/views/pages/reports/Credit-Loan/OnLendingReport.vue'),
  //   meta: {
  //     pageTitle: 'On-Lending Report',
  //     hasPermission: 'VIEW_SUBSCRIPTION_INVOICE', // change when available
  //     breadcrumb: [
  //       {
  //         text: 'Reports and Analytics',
  //       },
  //       {
  //         text: 'On-Lending Report',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/reports-analytics/account-balance-movement-report',
    name: 'account-balance-movement-report',
    component: () => import(
      '@/views/pages/reports/Operational/AccountBalanceMovementReport.vue'
    ),
    meta: {
      pageTitle: 'Account Balance Movement Report',
      hasPermission: 'ACCOUNT_BALANCE_MOVEMENT_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Account Balance Movement Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/deposit-balance-report',
    name: 'deposit-balance-report',
    component: () => import('@/views/pages/reports/Operational/DepositBalanceReport.vue'),
    meta: {
      pageTitle: 'Deposit Balance Report',
      hasPermission: 'DEPOSITS_BALANCE_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Deposit Balance Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/fixed-deposit-balance-report',
    name: 'fixed-deposit-balance-report',
    component: () => import('@/views/pages/reports/Operational/FixedDepositBalanceReport.vue'),
    meta: {
      pageTitle: 'Fixed Deposit Balance Report',
      hasPermission: 'FIXED_DEPOSITS_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Fixed Deposit Balance Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/daily-till-balance-report',
    name: 'daily-till-balance-report',
    component: () => import('@/views/pages/reports/Operational/DailyTillBalanceReport.vue'),
    meta: {
      pageTitle: 'Daily Till Balance Report',
      hasPermission: 'DAILY_TILL_BALANCE_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Daily Till Balance Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/active-account-report',
    name: 'active-account-report',
    component: () => import('@/views/pages/reports/Operational/ActiveAccountReport.vue'),
    meta: {
      pageTitle: 'Active Account Report',
      hasPermission: 'VIEW_ACTIVE_ACCOUNTS_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Active Account Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/marketers-performance-report',
    name: 'marketers-performance-report',
    component: () => import('@/views/pages/reports/Operational/MarketersPerformanceReport.vue'),
    meta: {
      pageTitle: 'Marketers Performance Report',
      hasPermission: reportPermissions.VIEW_MARKETERS_PERFORMANCE_REPORT,
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Marketers Performance Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/loan-repayment-expectation-report',
    name: 'loan-repayment-expectation-report',
    component: () => import(
      '@/views/pages/reports/Credit-Loan/LoanRepaymentExpectationReport.vue'
    ),
    meta: {
      pageTitle: 'Loan Repayment Expectation Report',
      hasPermission: 'LOAN_REPAYMENT_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Loan Repayment Expectation Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/chart-of-account',
    name: 'chart-of-account',
    component: () => import('@/views/pages/reports/Financial/ChartOfAccount.vue'),
    meta: {
      pageTitle: 'Chart of Accounts',
      hasPermission: 'VIEW_CHART_OF_ACCOUNT_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Chart of Accounts',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/balance-sheet-report',
    name: 'balance-sheet-report',
    component: () => import('@/views/pages/reports/Financial/BalanceSheetReport.vue'),
    meta: {
      pageTitle: 'Balance Sheet Report',
      hasPermission: 'VIEW_BALANCE_SHEET_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Balance Sheet Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/profit-loss-report',
    name: 'profit-loss-report',
    component: () => import('@/views/pages/reports/Financial/ProfitLossReport.vue'),
    meta: {
      pageTitle: 'Profit / Loss Report',
      hasPermission: 'VIEW_PROFIT_OR_LOSS_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Profit / Loss Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/trial-balance-report',
    name: 'trial-balance-report',
    component: () => import('@/views/pages/reports/Financial/TrialBalanceReport.vue'),
    meta: {
      pageTitle: 'Trial Balance Report',
      hasPermission: 'VIEW_TRIAL_BALANCE_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Trial Balance Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/periodic-trial-balance-report',
    name: 'periodic-trial-balance-report',
    component: () => import('@/views/pages/reports/Financial/PeriodicTrialBalance.vue'),
    meta: {
      pageTitle: 'Periodic Trial Balance Report',
      hasPermission: 'VIEW_TRIAL_BALANCE_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Periodic Trial Balance Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/icad-report',
    name: 'icad-report',
    component: () => import('@/views/pages/reports/Regulatory/ICADReport.vue'),
    meta: {
      pageTitle: 'ICAD Reports',
      hasPermission: 'ICAD_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'ICAD Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/credit-bureau-report',
    name: 'credit-bureau-report',
    component: () => import('@/views/pages/reports/Regulatory/CreditBureauReport.vue'),
    meta: {
      pageTitle: 'Credit Bureau Report',
      hasPermission: 'EXPORT_CREDIT_BUREAU_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Credit Bureau Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/disbursed-loan-report',
    name: 'disbursed-loan-report',
    component: () => import('@/views/pages/reports/Credit-Loan/DisbursedLoanReport.vue'),
    meta: {
      pageTitle: 'Disbursed Loan Report',
      hasPermission: 'DISBURSED_LOAN_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Disbursed Loan Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/ndic-report',
    name: 'ndic-report',
    component: () => import('@/views/pages/reports/Regulatory/NDICReport.vue'),
    meta: {
      pageTitle: 'NDIC Report',
      hasPermission: 'EXPORT_NDIC_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'NDIC Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/cbn-report',
    name: 'cbn-report',
    component: () => import('@/views/pages/reports/Regulatory/CBNReport.vue'),
    meta: {
      pageTitle: 'CBN Report',
      hasPermission: 'EXPORT_CBN_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'CBN Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/e-channel-transactions-report',
    name: 'e-channel-transactions-report',
    component: () => import('@/views/pages/reports/E-Channels/E-ChannelReport.vue'),
    meta: {
      pageTitle: 'E-Channel Transactions Report',
      hasPermission: 'VIEW_ECHANNEL_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'E-Channel Transactions Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/vat-wht-report',
    name: 'vat-wht-report',
    component: () => import('@/views/pages/reports/Operational/VATWHTReport.vue'),
    meta: {
      pageTitle: 'VAT & WHT Report',
      hasPermission: 'VAT_AND_WHT_REPORT',
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'VAT & WHT Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/anti-laundering-report',
    name: 'nfiu-report',
    component: () => import('@/views/pages/reports/Regulatory/NFIUReport.vue'),
    meta: {
      pageTitle: 'Anti-Money Laundering Report',
      hasPermission: reportPermissions.NFIU_REPORT,
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'Anti-Money Laundering',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/pep-report',
    name: 'pep-report',
    component: () => import('@/views/pages/reports/Regulatory/PEPReports.vue'),
    meta: {
      pageTitle: 'PEP Report',
      hasPermission: reportPermissions.VIEW_PEP_REPORT,
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: 'PEP Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports-analytics/three-tiered-kyc-report',
    name: 'three-tiered-kyc-report',
    component: () => import('@/views/pages/reports/Regulatory/ThreeTierKYC.vue'),
    meta: {
      pageTitle: '3-Tiered KYC Report',
      hasPermission: reportPermissions.THREE_TIERED_KYC_REPORT,
      breadcrumb: [
        {
          text: 'Reports and Analytics',
        },
        {
          text: '3-Tiered KYC Report',
          active: true,
        },
      ],
    },
  },
]
